import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Icon from "../../../components/Library/Icon";

import styles from "./SavedStories.css";

const SavedStoriesEmpty = () => {
  return (
    <div className={styles.savedStoriesEmpty}>
      <div>
        <Icon name="save" description="Save story" className={styles.emptyIcon} />
      </div>

      <h3 className={styles.emptyText}>{"You haven't saved any stories yet."}</h3>

      <div>
        <Link to="/" className={classNames(styles.blueButton1, styles.emptyButton)}>
          Read top stories
        </Link>
      </div>
    </div>
  );
};

export default SavedStoriesEmpty;



// WEBPACK FOOTER //
// ./src/users/components/SavedStories/SavedStoriesEmpty.js